var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.838,
    height: 20.239,
    viewBox: "0 0 19.838 20.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4285f4;}.b{fill:#34a853;}.c{fill:#fbbc04;}.d{fill:#ea4335;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M281.819,225.156a11.9,11.9,0,0,0-.175-2.056H272.1V227h5.466a4.684,4.684,0,0,1-2.023,3.075V232.6H278.8A9.882,9.882,0,0,0,281.819,225.156Z",
    transform: "translate(-261.981 -214.804)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M37.943,332.48a9.686,9.686,0,0,0,6.708-2.443l-3.261-2.528a6.137,6.137,0,0,1-9.124-3.209H28.9v2.606A10.12,10.12,0,0,0,37.943,332.48Z",
    transform: "translate(-27.824 -312.241)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.388,156.481a6.061,6.061,0,0,1,0-3.874V150H1.026a10.128,10.128,0,0,0,0,9.087Z",
    transform: "translate(0.05 -144.422)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M37.943,3.987A5.5,5.5,0,0,1,41.824,5.5h0l2.889-2.889A9.725,9.725,0,0,0,37.943-.018,10.117,10.117,0,0,0,28.9,5.56l3.361,2.606A6.053,6.053,0,0,1,37.943,3.987Z",
    transform: "translate(-27.824 0.018)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.f2b762fe.svg";
export { ForwardRef as ReactComponent };